import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type Theme = 'light' | 'dark' | 'system';

interface UiState {
  theme: Theme;
  sidebarCollapsed: boolean;
  mobileSidebarOpen: boolean;
  commandPaletteOpen: boolean;
}

const initialState: UiState = {
  theme: 'system',
  sidebarCollapsed: false,
  mobileSidebarOpen: false,
  commandPaletteOpen: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    themeChanged(state, action: PayloadAction<Theme>) {
      state.theme = action.payload;
    },
    sidebarToggled(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    sidebarCollapsedSet(state, action: PayloadAction<boolean>) {
      state.sidebarCollapsed = action.payload;
    },
    mobileSidebarOpened(state) {
      state.mobileSidebarOpen = true;
    },
    mobileSidebarClosed(state) {
      state.mobileSidebarOpen = false;
    },
    commandPaletteOpened(state) {
      state.commandPaletteOpen = true;
    },
    commandPaletteClosed(state) {
      state.commandPaletteOpen = false;
    },
  },
});

export const {
  themeChanged,
  sidebarToggled,
  sidebarCollapsedSet,
  mobileSidebarOpened,
  mobileSidebarClosed,
  commandPaletteOpened,
  commandPaletteClosed,
} = uiSlice.actions;

export const uiReducer = uiSlice.reducer;
